import { useEffect } from 'react';
import { useQuery } from '@apollo/client/react';

import {
    IUserListItemFragment,
    IUserSelectorQueryVariables,
    GroupUsersDocument,
} from 'graphql/types';
import { useApolloError } from 'common/hooks/useApolloError';

export interface IUserList {
    users: IUserListItemFragment[];
    alreadyAddedUsers: string[];
    usersCount?: number | null;
    loading: boolean;
}

export const useGroupUsersList = (
    userQueryVariables?: IUserSelectorQueryVariables
): IUserList => {
    const { showApolloError } = useApolloError();
    const { loading, data, error } = useQuery(GroupUsersDocument, {
        variables: {
            q: userQueryVariables?.q,
            offset: userQueryVariables?.offset,
            ...userQueryVariables,
        },
        notifyOnNetworkStatusChange: true,
    });

    useEffect(() => {
        if (error) {
            showApolloError(error);
        }
    }, [error, showApolloError]);

    const usersObject = data?.group?.users;
    const usersCount = usersObject?.count;
    const users =
        usersObject?.edges.map((edge) => edge?.node || null).filter(Boolean) ||
        [];

    return {
        users,
        alreadyAddedUsers: [],
        usersCount,
        loading,
    };
};
